import { useMemo } from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var useMediaProvider = function useMediaProvider(pluginInjectionApi) {
  var _useSharedPluginState = useSharedPluginState(pluginInjectionApi, ['media'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    mediaState = _useSharedPluginState.mediaState;
  var mediaProviderSelector = useSharedPluginStateSelector(pluginInjectionApi, 'media.mediaProvider', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var mediaProvider = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? mediaProviderSelector : mediaState === null || mediaState === void 0 ? void 0 : mediaState.mediaProvider;
  var provider = useMemo(function () {
    return mediaProvider;
  }, [mediaProvider]);
  return provider;
};